module.exports = __webpack_public_path__ + "img/amann.97879611.png";